var _ = require('underscore');
var SecureMessageWidget = require('./../secure-message/SecureMessageWidget');
var SecureMessageBillView = require('./SecureMessageBillView');
var financialFeatureService = require('./../financial/financialFeatureService');
var DemographicsDataBehavior = require('./../demographics/DemographicsDataBehavior');
var applicationUtils = require('./../applicationUtils');

var VIEW_NAME = 'billsDueListWidget';

/**
 * Customizations to the SecureMessageWidget specific to the bills due list page.
 * @class BillsDueListWidget
 * @constructor
 * @extends SecureMessageWidget
 */
module.exports = SecureMessageWidget.extend({
  moduleNamespace: VIEW_NAME,

  headerMessageKey: VIEW_NAME + '.header',
  noDataMessageKey: VIEW_NAME + '.noMessages',
  loadingMessageKey: VIEW_NAME + '.loading',
  fetchFailedMessageKey:  VIEW_NAME + '.fetchFailed',
  attributes: _.defaults({
    'data-test-bills-due-section' : 'true'
  }, SecureMessageWidget.prototype.attributes),
  itemView: SecureMessageBillView,

  behaviors: _.extend({}, SecureMessageWidget.prototype.behaviors, {
   demographics: {
     behavior: DemographicsDataBehavior,
     returnSingleResult: true,
     renderOnFetch: true,
     id: { property: '_patientVecnaId' }
   }
  }),

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    _.bindAll(this, '_checkPayAbility', '_updateBillStates');

    this._patientVecnaId = options.patientVecnaId;
    SecureMessageWidget.prototype.initialize.call(this, options);
    financialFeatureService.fetchPayAbility(options.patientVecnaId).then(this._checkPayAbility);

    var secureMessageDataBehavior = this.getBehavior('secureMessage');
    this.listenTo(secureMessageDataBehavior, 'fetched', this._updateBillStates);

    var demographicsDataBehavior = this.getBehavior('demographics');
    this.listenTo(demographicsDataBehavior, 'fetched', this._checkDemographics);
  },

  /**
   * The MixedMessageCriteria selecting the messages to display.
   *
   * @property criteria {Object}
   *   @property criteria.isPatient {Boolean} username restrictions apply to patient usernames only.
   *   @property criteria.vecnaIds {Array} Array of vecnaId restrictions
   *   @property criteria.billCriteria {Object} BillMessageCriteria - restrictions on bill messages.
   *     @property criteria.billCriteria.billCriteria {Object} restrictions on the bill itself.
   *       @property criteria.billCriteria.billCriteria.current {Boolean} only show the latest version of each bill.
   *       @property criteria.billCriteria.billCriteria.show {String} only show bills that are marked by the inbound integration as showable.
   *       @property criteria.billCriteria.billCriteria.minAccountBalance {String} only show bills with an account balance >= 0.01.
   */
  criteria: {
    billCriteria: {
      billCriteria: {
        current: true,
        show: true,
        minAccountBalance: 0.01
      }
    },
    isPatient: true,
    vecnaIds: null,
    pagingAndSorting: {
      pageNumber: 0,
      orderingMap: {
        actionDate: true
      },
      pageSize: 7
    }
  },

  /**
   * Check patient's ability to pay bills
   * @method _checkPayAbility
   * @private
   */
  _checkPayAbility: function() {
    var abilityToPayInfo = financialFeatureService.getAbleToPayState(this._patientVecnaId);
    var currentApplicationName = applicationUtils.currentApplication.name;
    if (!abilityToPayInfo.ableToPay) {
      this.set('additionalInformationKey', 'financial.feature.config.payment.blocked.' + currentApplicationName + '.' + abilityToPayInfo.unableToPayReason);
    }
    this._updateBillStates();
  },

  /**
   * Update the payment allowed state on each bill
   * @method _updateBillStates
   * @private
   */
  _updateBillStates: function() {
    var abilityToPayInfo = financialFeatureService.getAbleToPayState(this._patientVecnaId);
    _.each(this.getItemViews(), function(itemView) {
      itemView.setAbleToPay(abilityToPayInfo.ableToPay);
    });
  },

  /**
   * Show error message if fetching demographics failed.
   * @method _checkDemographics
   * @param fetchStatus {Object} fetch status and response of demographics data
   * @private
   */
  _checkDemographics: function(fetchStatus) {
    var fetchFailed = fetchStatus.status === 'failed';
    if (fetchFailed) {
      this.set('additionalInformationKey', 'billsDueListWidget.fetchDemographicsFailed');
    }
  }
});
